var React = require('react');

function Video (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10,8.64,15.27,12,10,15.36V8.64M8,5V19l11-7Z","transform":"translate(-8 -5)","fill":"#fff"}));
}

Video.defaultProps = {"width":"11","height":"14","viewBox":"0 0 11 14"};

module.exports = Video;

Video.default = Video;
